import { ICellRendererParams } from 'ag-grid-community';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { ActionsMenuColumn } from '../../shared/grid-columns';
import { isEmpty } from 'lodash';
import { ViewChild } from '@angular/core';

export interface ActionsMenuItem {
    title: string;
    onClick: () => void;
}

interface ActionsMenuCellRenderer<TEntity> extends ICellRendererParams {
    data: TEntity;
    colDef: ActionsMenuColumn<TEntity>;
}

export abstract class ActionsMenuAgRendererComponent<TEntity> implements AgRendererComponent {
    public menuItems: ActionsMenuItem[];
    public isMenuItemsEmpty: boolean;

    @ViewChild('cultureMenu')
    public cultureMenu: any;

    @ViewChild('cultureMenuBtn')
    public cultureMenuBtn: any;
    private row: ActionsMenuCellRenderer<TEntity>;

    public refresh(): boolean {
        return false;
    }

    public agInit(row: ActionsMenuCellRenderer<TEntity>) {
        this.row = row;
        this.menuItems = this.createMenuItems(row.data, row.colDef);
        this.isMenuItemsEmpty = isEmpty(this.menuItems);
    }

    public toggleMenu($event: any, cultureMenuBtn: any) {
        const menuDirection = this.row.api.getVerticalPixelRange().bottom - this.row.node.rowTop - this.row.node.rowHeight < this.cultureMenu.menuElement.clientHeight 
            ? 'top-right' 
            : 'bottom-right';
        this.cultureMenu.position = menuDirection;
        this.cultureMenu.toggle($event, cultureMenuBtn);
    }


    public abstract createMenuItems(data: TEntity, colDef: ActionsMenuColumn<TEntity>): ActionsMenuItem[];
}